import { createFileRoute } from '@tanstack/react-router';
import Bio from 'src/pages/Organization/Players/Bio';

export const Route = createFileRoute('/$organizationSlug/players/$playerId/')({
  component: Bio,
});
